import { annualCards } from '../../../mocks/entertainment';
import SectionHead from './SectionHead';

export default function AnnualRecap() {
  return (
    <section id="annual" className="relative scroll-mt-16 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHead
            eyebrow="年度大瓜回顾"
            title="娱乐圈年度备忘录"
            desc="把每一年搅动全网的大瓜、爆款与名场面按时间归档，想考古哪一年，翻到哪一页。"
          />
          <a
            href="#subscribe"
            className="inline-flex shrink-0 items-center self-start whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 lg:self-auto"
          >
            订阅每年盘点
            <i className="ri-arrow-right-line ml-1.5" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-2">
          {annualCards.map((card) => (
            <article
              key={card.year}
              className="group flex flex-col overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-200/80 transition-colors hover:ring-accent-300"
            >
              <div className="relative overflow-hidden">
                <div className="aspect-[16/9] w-full overflow-hidden">
                  <img
                    src={card.img}
                    alt={`${card.year}年${card.label}专题封面，${card.title}`}
                    title={`${card.year} · ${card.title}`}
                    className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute left-3 top-3 flex items-center gap-2">
                  <span className="rounded-md bg-background-950/55 px-2.5 py-1 text-xs font-bold text-background-50 backdrop-blur">
                    {card.label}
                  </span>
                  <span className="rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-950">
                    {card.year}
                  </span>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-5 md:p-6">
                <h3 className="text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                  {card.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{card.summary}</p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-folder-open-line" aria-hidden="true"></i>
                    {card.point}
                  </span>
                  <a
                    href="#faq"
                    className="inline-flex items-center whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
                  >
                    展开详情
                    <i className="ri-arrow-right-up-line ml-1" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}